import axios from "axios";

const service = axios.create({
  //基础路径
  baseURL: "/api",
  //请求超时
  timeout: 5000,
});

//请求拦截器 在发请求之前
service.interceptors.request.use((config) => {
  //config: 配置对象 包含请求头 headers
  return config;
});

//响应拦截器
service.interceptors.response.use(
  (res) => {
    //成功的回调函数
    return res.data;
  },
  (error) => {
    //响应失败回调
    return Promise.reject(new Error("faile"));
  }
);

//对外暴露
export default service;
